import { Button, Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Box, Flex } from '@betterment/style-closet-react';

import { trackClick } from '../../features/track';
import { ContentCardProps } from '../data';

const AccountLevelBanner: React.FC<ContentCardProps> = ({
  description,
  linkText,
  dismissible,
  url,
  handleDismissal,
  handleCardClick,
  trackingModule: eventModule,
  trackingFlow: eventFlow,
  extras: { name: eventName, linkTarget },
}) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      p="8"
      backgroundColor="bmtBlue10"
      data-testid="accountLevelBanner"
    >
      <Flex alignItems="center">
        <Box mr="6">
          {description && <Text color="text" dangerouslySetInnerHTML={{ __html: description }} />}
          {url && linkText && (
            <>
              {' '}
              <SambaAutoLink
                to={url}
                target={linkTarget}
                rel="noopener noreferrer"
                onClick={event => {
                  trackClick({ name: `${eventName}_${linkText}`, module: eventModule, flow: eventFlow });
                  handleCardClick(event);
                }}
                data-testid="contentCardLink"
              >
                {linkText}
              </SambaAutoLink>
            </>
          )}
        </Box>
      </Flex>
      {dismissible && (
        <Button aria-label="Dismiss card" onClick={handleDismissal} variant="ghostSecondary" spacing="compact">
          <Icon name="X" size="small" color="icon.accent.navy" />
        </Button>
      )}
    </Flex>
  );
};

export default AccountLevelBanner;
